
import React from "react";
import "./Crane_Rental.css";
import { Link } from "react-router-dom";
import Roofrepair from './Category/Relocation_of_buildings';







export default function Crane_Rental() {


  const items = [
    { title: "  השכרת מנוף סל", img: "/images/6.jpeg", path: "/Basket_crane_rental"},
    { title: "    השכרת מנוף זרוע", img: "/images/37.jpeg" , path: "/Crane_Rental1"},
    { title: "  השכרת סל הרמה לפי שעה", img: "/images/1.jpeg" , path: "/Hourly_Lifting_Basket_Rental"},
    { title: "  השכרת מנוף סל להרמת אדם", img: "/images/24.jpeg", path: "/Renting_a_basket_crane_for_lifting_a_person"},
  
  ];







  return (

    <div className="Crane_Rental-page">
      <div className="Crane_Rental-hero">
        <div className="Crane_Rental-overlay">
          <h1>   השכרת מנופים</h1>
        </div>

<div>
</div>
</div>

    <div className="page2">



       <div className="grid2">
          {items.map((item, index) => (
            
            <Link to={item.path} key={index} className="card2">

              <img src={item.img} alt={item.title} />

              <div className="card2-btn">
                {item.title}
              </div>

            </Link>
        ))}
      </div>
    </div>


      </div>
  );
}


